var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    rx: 20,
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 20,
    r: 12,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 20,
    r: 12,
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 20,
    r: 12,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 12,
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLight);
export default __webpack_public_path__ + "static/media/yellowLight.1e66fa06445d931e003bb4c2cff0c9b4.svg";
export { ForwardRef as ReactComponent };